module.exports = __webpack_public_path__ + "img/⾼效的边缘计算能⼒.07265665.png";